import { BaseSettings } from '../../common/component-settings/base-settings.model';
export class MyActionCenterModalComponentSettings extends BaseSettings {
    constructor() {
        super(...arguments);
        this.documentStates = [];
    }
}
